import Icon from '../components/Icon';

const ThumbsDown = Icon(
  'thumbs-down',
  <>
    <path
      fillRule="evenodd"
      d="M12.17 22.455a.75.75 0 0 0 .925-.344L16.946 15H21a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5h-4.485l-.014-.001H6.76a3.75 3.75 0 0 0-3.663 2.947L1.535 13.82a2.75 2.75 0 0 0 2.686 3.339h4.586v.742a4.75 4.75 0 0 0 3.066 4.441zm5.082-8.955V5.25H21v8.25zM15.75 5.25H6.76a2.25 2.25 0 0 0-2.198 1.768L3 14.141a1.25 1.25 0 0 0 1.22 1.518h5.337a.75.75 0 0 1 .75.75V17.9c0 1.237.701 2.356 1.79 2.903l3.653-6.745z"
      clipRule="evenodd"
    />
  </>
);

export default ThumbsDown;
